/**
 * 2026-04-25 — GM·디버그용 치트 API.
 *
 * 프론트 진입점은 히든 (idkfa 타이핑). 일반 유저 노출 X.
 */
import { apiGet, apiPost } from "@/api/client";
import type { InventoryItemView } from "@/api/types";

export interface CheatCatalogEntry {
    id: string;
    name: string;
    category: string;
}

export function cheatCatalog(): Promise<CheatCatalogEntry[]> {
    return apiGet<CheatCatalogEntry[]>("/api/v1/public/game/cheat/catalog");
}

export function cheatSetGold(runId: string, value: number): Promise<number> {
    return apiPost<number>(
        `/api/v1/public/game/runs/${encodeURIComponent(runId)}/cheat/gold`,
        { value },
    );
}

export function cheatGrantItem(runId: string, itemId: string, quantity: number): Promise<InventoryItemView> {
    return apiPost<InventoryItemView>(
        `/api/v1/public/game/runs/${encodeURIComponent(runId)}/cheat/grant-item`,
        { itemId, quantity },
    );
}

export type CheatBundle = "refine" | "engrave" | "all";

export function cheatBundle(runId: string, bundle: CheatBundle): Promise<number> {
    return apiPost<number>(
        `/api/v1/public/game/runs/${encodeURIComponent(runId)}/cheat/bundle`,
        { bundle },
    );
}

export function cheatSetTraining(runId: string, pathId: string, value: number): Promise<Record<string, number>> {
    return apiPost<Record<string, number>>(
        `/api/v1/public/game/runs/${encodeURIComponent(runId)}/cheat/training`,
        { pathId, value },
    );
}

export function cheatSetEnhancement(runId: string, instanceId: string, value: number): Promise<InventoryItemView> {
    return apiPost<InventoryItemView>(
        `/api/v1/public/game/runs/${encodeURIComponent(runId)}/cheat/enhance`,
        { instanceId, value },
    );
}
